module.exports = __webpack_public_path__ + "static/media/21ECLAC17.85bd910e.jpg";